export default __webpack_public_path__ + "static/media/books-2048w.6f2d2ab5.png";